import { render, staticRenderFns } from "./TrainNotice.vue?vue&type=template&id=5cd3f533&scoped=true&"
import script from "./TrainNotice.vue?vue&type=script&lang=js&"
export * from "./TrainNotice.vue?vue&type=script&lang=js&"
import style0 from "./TrainNotice.vue?vue&type=style&index=0&id=5cd3f533&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd3f533",
  null
  
)

export default component.exports